import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=6b44e0ae"
import script from "./ProjectForm.vue?vue&type=script&lang=js"
export * from "./ProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports